import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-back',
  templateUrl: './back.component.html',
  styleUrls: ['./back.component.scss']
})
export class BackComponent implements OnInit {
  constructor() {}
  ngOnInit() {
      window.location.href = environment.wp.frontend_base; // Redirect to a default page
    }
}
